import { CustomerReference } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateCustomerReference: (
  fetchContext: FetchContext,
  customerReference: CustomerReference,
  accessToken?: string,
) => Promise<void> = (fetchContext, customerReference, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/customer-references/${customerReference.customerReferenceId}`, {
    method: 'PUT',
    body: JSON.stringify(customerReference),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update customer reference'));
